import { action } from 'satcheljs';
import { OwaDate } from 'owa-datetime';

export const setCustomReminderDate = action(
    'setCustomReminderDate',
    (customReminderDate: OwaDate) => ({
        customReminderDate,
    })
);

export const setSelectedDate = action('setSelectedDate', (date: OwaDate) => ({ date }));

export const setSelectedTime = action('setSelectedTime', (dateTime: OwaDate) => ({ dateTime }));
